module.exports = __webpack_public_path__ + "static/media/8_bsp.4ae290de.mp3";